import styled from 'styled-components';
import { Tabs, Text, TextTag } from '@volkswagen-onehub/components-core';
import { StandardEquipment, TechnicalSpecification } from '@volkswagen-onehub/icons-core';
import { useTranslation } from 'react-i18next';
import { TechnicalInformation } from '@/components/technicalInformation/technicalInformation';
import { minimalScreenWidth } from '@/common/breakpoints';
import { EquipmentAccordion } from '../equipmentAccordion/equipmentAccordion';
import { useContext } from 'react';
import { GiveawayContext } from '@/state/state';

export const EquipmentList = () => {
  return (
    <>
      <EquipmentAccordion />
    </>
  );
};

type VehicleInformationProps = {
  showEquipmentFeature: boolean;
  showTechnicalDataFeature: boolean;
};

const StyledText = styled(Text)`
  align-items: center;
  display: flex;
`;

const StyledContainer = styled.section`
  padding-left: ${(props) => props.theme.size.dynamic0150};
  padding-right: ${(props) => props.theme.size.dynamic0150};
  padding-bottom: ${(props) => props.theme.size.dynamic0270};
  padding-top: ${(props) => props.theme.size.dynamic0270};

  @media screen and ${minimalScreenWidth.l} {
    justify-content: left;
    padding-left: ${(props) => props.theme.size.dynamic0250};
    padding-right: ${(props) => props.theme.size.dynamic0250};
    padding-bottom: ${(props) => props.theme.size.dynamic0270};
    padding-top: ${(props) => props.theme.size.dynamic0270};
  }

  @media screen and ${minimalScreenWidth.xl} {
    padding-left: ${(props) => props.theme.size.dynamic0450};
    padding-right: ${(props) => props.theme.size.dynamic0450};
    padding-top: ${(props) => props.theme.size.dynamic0270};
    padding-bottom: ${(props) => props.theme.size.dynamic0270};
  }
`;

export const VehicleInformation = (props: VehicleInformationProps): JSX.Element => {
  const { t } = useTranslation();
  const { technicalData } = useContext(GiveawayContext);

  const hasTechnicalData = technicalData?.some(
    (item) => Array.isArray(item.values) && item.values.length > 0,
  );

  return (
    <StyledContainer>
      <Tabs
        variant="underlined"
        aria-label={t('body.details.vehicleInformations.tabs.ariaLabel')}
        idPrefix={'vehicle-information'}
      >
        {[
          ...(props.showEquipmentFeature
            ? [
                {
                  title: (
                    <StyledText tag={TextTag.span}>
                      <StandardEquipment variant="default" aria-hidden="true" />
                      {t('equipmentAccordion.headline')}
                    </StyledText>
                  ),
                  content: <EquipmentList key="equipmentList" />,
                  key: 'equipment',
                },
              ]
            : []),
          ...(props.showTechnicalDataFeature && hasTechnicalData
            ? [
                {
                  title: (
                    <StyledText tag={TextTag.span}>
                      <TechnicalSpecification variant="default" aria-hidden="true" />
                      {t('body.details.vehicleInformations.technicalData.title')}
                    </StyledText>
                  ),
                  content: <TechnicalInformation key="technicaldata" />,
                  key: 'technicaldata',
                },
              ]
            : []),
        ]}
      </Tabs>
    </StyledContainer>
  );
};
